<template>
  <div class="progress-bar margin-y-md">
    <div style="height: var(--spacing-md); background-color: var(--gray-100); border-radius: var(--border-radius-pill); margin-bottom: var(--spacing-sm)">
      <div
        :style="`height: var(--spacing-md); border-radius: var(--border-radius-pill); min-width: var(--spacing-md); background-color: var(${progressBar.color}); width: ${progressBar.size};`"
      />
    </div>
    <dl
      v-if="isShowingDetails"
      class="margin-0 padding-0"
    >
      <dt class="sr-only">Current Usage</dt>
      <dd class="display-flex flex-content-between muted size-sm">
        <span v-if="isShowingPercentage && currentPercentage > 0">{{ formatNumber(currentPercentage, { precision: precision }) }}%</span>
        <span v-else-if="isShowingLabel">{{ label }}</span>

        <span v-if="unlimited">
          {{ value }} of
          <font-awesome-icon :icon="$v6.regular.faInfinity" />
        </span>
        <span v-else>{{ value }} of {{ limit }}{{ unit }}</span>
      </dd>
    </dl>
  </div>
</template>

<script>
  import UtilsMixin from 'app/views/UtilsMixin'

  export default {
    name: 'ProgressBar',

    mixins: [UtilsMixin],

    props: {
      value: {
        type: [Number, String],
        required: true
      },
      label: {
        type: String,
        default: null
      },
      limit: {
        type: [Number, String],
        required: true
      },
      unit: {
        type: String,
        required: false
      },
      unlimited: {
        type: Boolean,
        default: false
      },
      isShowingPercentage: {
        type: Boolean,
        default: true
      },
      warningPercentage: {
        type: Number,
        default: 60
      },
      dangerPercentage: {
        type: Number,
        default: 90
      },
      errorPercentage: {
        type: Number,
        default: 100
      },
      precision: {
        type: Number,
        default: 0
      },
      isShowingDetails: {
        type: Boolean,
        default: true
      },
      isShowingStatefulColor: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      currentPercentage() {
        const progressValue = typeof this.value === 'string' ? Number(this.value.split(',').join('')) : this.value
        const progressLimit = typeof this.limit === 'string' ? Number(this.limit.split(',').join('')) : this.limit

        return Math.round((progressValue / progressLimit) * 100)
      },

      isShowingLabel() {
        return this.label && !this.isShowingPercentage
      },

      size() {
        if (this.currentPercentage > 100) {
          return '100%'
        } else {
          return `${this.currentPercentage}%`
        }
      },

      progressBar() {
        if ((this.value === 0 && this.unlimited) || (this.value === 0 && !this.isShowingStatefulColor)) {
          return {
            color: '--fa-gravy',
            size: 0
          }
        } else if (this.unlimited) {
          return {
            color: '--fa-gravy',
            size: '10%'
          }
        } else if (!this.isShowingStatefulColor) {
          return {
            color: '--fa-gravy',
            size: this.size
          }
        } else if (this.isShowingStatefulColor && this.currentPercentage >= this.errorPercentage) {
          return {
            color: '--fa-dk-red',
            size: this.size
          }
        } else if (this.isShowingStatefulColor && this.currentPercentage >= this.dangerPercentage) {
          return {
            color: '--fa-dk-yellow',
            size: this.size
          }
        } else if (this.isShowingStatefulColor && this.currentPercentage >= this.warningPercentage) {
          return {
            color: '--fa-dk-blue',
            size: this.size
          }
        } else {
          return {
            color: '--fa-gravy',
            size: this.size
          }
        }
      }
    }
  }
</script>
